/**
 * Strip invisible characters often pasted from Word/PDF/IME (e.g. zero-width space)
 * that break strict URL validation while leaving the visible URL unchanged.
 */
export function sanitizeUrlInput(raw) {
  if (raw == null || typeof raw !== "string") return raw;
  return raw.replace(/[\u200B-\u200D\uFEFF\u2060\u00AD\u061C\u200E\u200F]/g, "").trim();
}
